import { Box, IconButton, TextField, Typography } from "@mui/material"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import PhoneIcon from "@mui/icons-material/Phone"
import MessageIcon from "@mui/icons-material/Message"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import {
  GroupInfoAdvisor,
  GroupInfoAdvisorLeft,
  GroupInfoAdvisorRight,
  GroupInfoContact,
  GroupInfoContactSectionOne,
  GroupInfoContactSectionOneLeft,
  GroupInfoContactSectionOneRight,
  GroupInfoContactSectionThree,
  GroupInfoContactSectionTwo,
  LogoutWrapper,
  GroupInfoDeactivateButton,
  GroupInfoHeader,
  GroupInfoHeaderIconActiveButton,
  MyInfoHeaderIconWrapper,
  MyInfoHeaderLeft,
  GroupInfoRegion,
  GroupInfoRegionSectionOne,
  GroupInfoRegionSectionOneLeft,
  GroupInfoRegionSectionTwo,
  GroupInfoRegionSectionTwoLeft,
  GroupInfoRegionSectionTwoRight,
  GroupInfoWrapper,
  groupInfoIconStyle,
  GroupInfoContactSectionThreeLeft,
  ChangePasswordWrapper,
  ChangePasswordButton,
} from "./Atom"
import { StatusButton } from "../../Button"
import { useState } from "react"
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone"
import SaveIcon from "@mui/icons-material/Save"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import MyInfoConfirmation from "../../Modal/MyInfoConfirmation"
import { useNavigate } from "react-router-dom"

function MyInfoCard(props: any) {
  const { currentUser, handleLogout, updateUserContactNumber } = props

  const navigate = useNavigate()

  const [isContactNumberEditActive, setIsContactNumberEditActive] =
    useState(false)
  const [contactNumberValue, setContactNumberValue] = useState("")
  const [open, setOpen] = useState(false)

  const handleChangeContactNumber = async () => {
    if (contactNumberValue) {
      setOpen(true)
    }
    setIsContactNumberEditActive(false)
  }

  return (
    <>
      <MyInfoConfirmation
        open={open}
        setOpen={setOpen}
        currentContactNumber={currentUser?.contact_number}
        newContactNumber={contactNumberValue}
        setContactNumberValue={setContactNumberValue}
        setIsContactNumberEditActive={setIsContactNumberEditActive}
        updateUserContactNumber={updateUserContactNumber}
      />
      <GroupInfoWrapper>
        {/* Group Info Header Section */}

        <GroupInfoHeader>
          <MyInfoHeaderLeft>
            <MyInfoHeaderIconWrapper>
              <AccountCircleIcon
                sx={{
                  fontSize: "160px",
                }}
              />
            </MyInfoHeaderIconWrapper>

            <Box
              sx={{
                // marginLeft: "18px",
                // border: "1px solid red",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                fontWeight={500}
                color={"#414241"}
                fontSize={18}
                sx={{ whiteSpace: "nowrap" }}
                textTransform={"capitalize"}
              >
                {`${currentUser?.first_name} ${currentUser?.last_name}`}
              </Typography>
              <Typography
                fontWeight={400}
                color={"#147AD6"}
                fontSize={14}
                textTransform={"capitalize"}
              >
                {`${currentUser?.role_display_name}`}
              </Typography>
            </Box>
          </MyInfoHeaderLeft>

          {/* <IconButton sx={{ alignSelf: "flex-start" }}>
                        <EditTwoToneIcon sx={{ color: "#707070", cursor: "pointer" }} fontSize="small" />
                    </IconButton> */}
        </GroupInfoHeader>

        {/* contact details */}

        <GroupInfoContact>
          {/* <GroupInfoContactSectionOne>
                        <GroupInfoContactSectionOneLeft>
                            <Typography
                                color={"#707170"}
                                fontSize={"12px"}
                            >
                                Email ID
                            </Typography>
                            <Typography
                                color={"#3366D6"}
                                fontSize={"14px"}
                            >
                                Kennedi Cross
                            </Typography>
                            <Typography
                                color={"#414241"}
                                fontSize={"12px"}
                            >

                            </Typography>
                        </GroupInfoContactSectionOneLeft>
                        <GroupInfoContactSectionOneRight>
                        </GroupInfoContactSectionOneRight>
                    </GroupInfoContactSectionOne> */}

          <GroupInfoContactSectionTwo>
            <Typography color={"#707170"} fontSize={12} fontWeight={400}>
              Email ID
            </Typography>
            <Typography color={"#414241"} fontSize={14} fontWeight={500}>
              {`${currentUser?.email}`}
            </Typography>
          </GroupInfoContactSectionTwo>

          <GroupInfoContactSectionThree>
            <GroupInfoContactSectionThreeLeft>
              {isContactNumberEditActive ? (
                <TextField
                  onChange={(e: any) => setContactNumberValue(e.target.value)}
                  defaultValue={currentUser?.contact_number}
                />
              ) : (
                <>
                  <Typography color={"#707170"} fontSize={"12px"}>
                    Contact Number
                  </Typography>
                  <Typography color={"#414241"} fontSize={"14px"}>
                    {currentUser?.contact_number || `-`}
                  </Typography>
                </>
              )}
            </GroupInfoContactSectionThreeLeft>
            <IconButton
            // onBlur={() => setIsAdvisorEditActive(false)}
            >
              {isContactNumberEditActive ? (
                <SaveIcon
                  sx={{ color: "#3C77EF", cursor: "pointer" }}
                  fontSize="small"
                  onClick={() => handleChangeContactNumber()}
                />
              ) : !currentUser?.contact_number ? (
                <AddCircleOutlineIcon
                  sx={{ color: "#707070", cursor: "pointer" }}
                  fontSize="small"
                  onClick={() => {
                    setIsContactNumberEditActive(true)
                  }}
                />
              ) : (
                <EditTwoToneIcon
                  sx={{ color: "#707070", cursor: "pointer" }}
                  fontSize="small"
                  onClick={() => {
                    setIsContactNumberEditActive(true)
                  }}
                />
              )}
            </IconButton>
          </GroupInfoContactSectionThree>

          {/* <GroupInfoContactSectionThree>
                        <Typography
                            color={"#707170"}
                            fontSize={"12px"}
                        >
                            Created By
                        </Typography>
                        <Typography
                            color={"#414241"}
                            fontSize={"14px"}
                        >
                            John Doe
                        </Typography>
                    </GroupInfoContactSectionThree> */}
        </GroupInfoContact>

        {/* Advisor Details */}

        {/* <GroupInfoAdvisor>

                    <GroupInfoAdvisorLeft>
                        <Typography
                            color={"#707170"}
                            fontSize={"12px"}
                        >
                            Advisor
                        </Typography>
                        <Typography
                            color={"#3366D6"}
                            fontSize={"14px"}
                        >
                            Gavin Cooper
                        </Typography>
                    </GroupInfoAdvisorLeft>

                    <GroupInfoAdvisorRight>
                        <PhoneIcon
                            sx={groupInfoIconStyle}
                            fontSize="small"
                        />
                        <MessageIcon
                            sx={groupInfoIconStyle}
                            fontSize="small"
                        />
                        <CalendarMonthIcon
                            sx={groupInfoIconStyle}
                            fontSize={"small"}
                        />
                    </GroupInfoAdvisorRight>
                </GroupInfoAdvisor> */}

        {/* regions details */}

        {/* <GroupInfoRegion>
                    <GroupInfoRegionSectionOne>
                        <GroupInfoRegionSectionOneLeft>
                            <Typography
                                sx={{
                                    color: "#707170",
                                    fontSize: "12px"
                                }}
                            >
                                Groups
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#414241",
                                    fontSize: "14px",
                                    fontWeight: "bold"
                                }}
                            >
                                2
                            </Typography>
                        </GroupInfoRegionSectionOneLeft>
                    </GroupInfoRegionSectionOne>
                    <GroupInfoRegionSectionTwo>
                        <GroupInfoRegionSectionTwoLeft>
                            <Typography
                                sx={{
                                    color: "#707170",
                                    fontSize: "12px"
                                }}
                            >
                                Regions
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#414241",
                                    fontSize: "14px",
                                    fontWeight: "bold"
                                }}
                            >
                                7
                            </Typography>
                        </GroupInfoRegionSectionTwoLeft>
                        <GroupInfoRegionSectionTwoRight>
                            <Typography
                                sx={{
                                    color: "#707170",
                                    fontSize: "12px"
                                }}
                            >
                                Offices
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#414241",
                                    fontSize: "14px",
                                    fontWeight: "bold"
                                }}
                            >
                                19
                            </Typography>
                        </GroupInfoRegionSectionTwoRight>
                    </GroupInfoRegionSectionTwo>
                </GroupInfoRegion> */}

        {/* Deactivate button */}

        <ChangePasswordWrapper>
          <ChangePasswordButton
            variant="text"
            onClick={() => navigate("/changePassword")}
          >
            Change Password
          </ChangePasswordButton>
        </ChangePasswordWrapper>
        <LogoutWrapper>
          <GroupInfoDeactivateButton
            variant="text"
            onClick={() => handleLogout()}
          >
            Logout
          </GroupInfoDeactivateButton>
        </LogoutWrapper>
      </GroupInfoWrapper>
    </>
  )
}
export default MyInfoCard
